export default __webpack_public_path__ + "static/media/chest_press_end.4d280925.svg";